__turbopack_context__.v({
  "providerPageLayout": "providerPageLayout-module-scss-module__-t0lkW__providerPageLayout",
});
